import TableListingComp from './TableListing.vue'
import LoadOnVisibleComp from './LoadOnVisible.vue'
import ActiveFiltersCardComp from './ActiveFiltersCard.vue'
import InventoryStatusBadgeComp from './InventoryStatusBadge.vue'

export const LoadOnVisible = LoadOnVisibleComp
export const TableListing = TableListingComp
export const ActiveFiltersCard = ActiveFiltersCardComp
export const InventoryStatusBadge = InventoryStatusBadgeComp
export default {
  InventoryStatusBadge: InventoryStatusBadgeComp,
  LoadOnVisible: LoadOnVisibleComp,
  TableListing: TableListingComp,
  ActiveFiltersCard: ActiveFiltersCardComp
}
